// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationDeterminationResponse {
    'transactionCorrelationId': string;
    'transactionStatus': boolean;
    'transactionMessages': Array<string>;
    'transactionDateTime': Moment;
    'paRequired': boolean;
    'serviceDate': Moment;
    'portalUrl'?: string;
    'providerPinNumber'?: string;
    'providerNpi'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationDeterminationResponse>> = [
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
        {
            "name":     "transactionMessages",
            "baseName": "transactionMessages",
            "type":     "Array<string>"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "paRequired",
            "baseName": "paRequired",
            "type":     "boolean"
        },
        {
            "name":     "serviceDate",
            "baseName": "serviceDate",
            "type":     "Date"
        },
        {
            "name":     "portalUrl",
            "baseName": "portalUrl",
            "type":     "string"
        },
        {
            "name":     "providerPinNumber",
            "baseName": "providerPinNumber",
            "type":     "string"
        },
        {
            "name":     "providerNpi",
            "baseName": "providerNpi",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationDeterminationResponse.attributeTypeMap;
    }
}
